import { isNullOrUndefined } from 'utils/utils';

/**
 * Convert a snake-case ENUM value (e.g. "TAX_RESIDENCE, DOMICILE") to sentence case ("Tax residence, Domicile")
 * @param enumString the enum to convert
 */
export function formatEnum(enumString: string): string {
  if (!enumString) {
    return '-';
  }
  return (
    enumString.charAt(0) +
    enumString
      .slice(1)
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/,\s*([a-z])/g, function (d, e) {
        return ', ' + e.toUpperCase();
      })
  );
}

/**
 * Convert a raw date string (e.g "2020-05-06T10:46:46.283+0000") to legible date format (06.05.2020.)
 * @param date the enum to convert
 */
export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('en-GB').replace(/\//g, '.');
}

export const arrayUniqueByKey = (array: any[], key: string) => [...new Set(array.map((item) => item[key]))];
/**
 * Remove all space and special characters from a string
 * @param inputString the string to transform
 */
export const removeWhitespaceSpecialCharacters = (inputString: string) => {
  return inputString.replace(/[^A-Z0-9]/gi, '');
};

export const kebabToTitleCase = (kebabCase: string) =>
  kebabCase ? kebabCase.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '';

export const getPartnerPageTitle = (isUatEnvironment: boolean, partnerId?: string) => {
  return isUatEnvironment || isNullOrUndefined(partnerId) ? 'Partner' : `Partner: ${partnerId}`;
};
